import styled from 'styled-components';

export const StyledLoadingSpinnerContainer = styled.div`
  position: relative;
  width: 100%;
`;
